<template>
    <clickable-list-item :is-last="isLast" @click="handleSelect">
        <template #middle>
            <g-typography tag="div" font-weight="semibold">{{ dateString }}</g-typography>
            <g-typography class="clickable-list-item__subtitle g-pr-3 g-mt-2" color="grey-6" :value="label" />
            <div class="g-mt-2">
                <payout-status :payout="payout" :is-conversion="isConversion" :is-paid-to-agent="isPaidToAgent" />
            </div>
        </template>

        <template #right>
            <g-typography size="h3">
                <money-display :value="amountString" :currency="payout.currency" />
            </g-typography>
        </template>
    </clickable-list-item>
</template>

<script>
    import { computed } from 'vue-demi';
    import { shortDate } from '../../../../helpers';
    import PayoutStatus from './PayoutStatus.vue';
    import MoneyDisplay from '../../../interface/elements/MoneyDisplay.vue';
    import ClickableListItem from '../../../../../app-v2/components/library/ClickableListItem.vue';

    export default {
        name: 'PaymentClickableListItem',

        components: {
            PayoutStatus,
            MoneyDisplay,
            ClickableListItem
        },

        props: {
            payout: {
                type: Object,
                default: null
            },
            isConversion: {
                type: Boolean,
                default: false
            },
            isLast: {
                type: Boolean,
                default: false
            },
            handleSelect: {
                type: Function,
                default: () => {}
            }
        },

        setup(props) {
            const amountString = computed(() => {
                const amount = props.isConversion
                    ? props.payout.earned
                    : props.payout.amount - props.payout.withholding_amount;

                return props.payout.is_voided ? 0 : amount;
            });

            const dateString = computed(() => {
                return shortDate(props.payout.created_at);
            });

            const label = computed(() => {
                return props.isConversion ? props.payout.resource : props.payout.brand?.name;
            });

            const isPaidToAgent = computed(() => {
                return props.payout?.is_paid_to_agent ?? false;
            });

            return {
                isPaidToAgent,
                amountString,
                dateString,
                label
            };
        }
    };
</script>

<style lang="scss" scoped>
    ::v-deep .media-object-container {
        height: 109px;
    }

    .clickable-list-item ::v-deep .media-object-content {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>
